export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-lightbulb-10c93ae4ec393c87c91cc26d446fb51e.svg";